<template>
    <div class="sup-ecological-patrner-comp">
        <div class="re-w1200 re-main-col">
            <div class="top-box">
                <span class="top-title">生态伙伴</span>
                <div class="top-line"></div>
            </div>
            <div class="e-p-content-box">
                <div class="grid-list-box" :class="{ 'grid-list-box-unfold': !partner_list_fold }" ref="ref_partner_grid_list_box">
                    <div class="grid-page-box" v-for="(page, pageIndex) in partner_page_list_computed" :key="`page_${pageIndex}`">
                        <div
                            class="grid-item-box"
                            :style="partner_page_list_size_computed(item)"
                            v-for="(item, index) in page.gridList"
                            :key="`item_${pageIndex}_${index}`">
                            <img :src="require(`@/assets/imgs/home/partner_icon_light/${item.icon}.png`)" />
                            <span>{{ item.index }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="e-p-fold-box">
                <div class="e-p-fold-btn" @click="partner_page_list_fold_click()">
                    <img class="btn-img" :class="{ 'btn-img-unfold': partner_list_fold }" src="@/assets/imgs/home/icon_fold.png" />
                </div>
            </div>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, computed } from 'vue';

const ref_partner_grid_list_box = ref(null);
const partner_grid_line = ref(1); // 每页显示的几行
const partner_grid_line_count = ref(5); // 每行显示的几个
const partner_grid_min_line = ref(5); //默认展示几行
const partner_list = ref([
    { icon: 'icon_shanghaihezuozuzhi', size: 0 },
    { icon: 'icon_zhongguoshizheng', size: 0 },
    { icon: 'icon_gongluxuehui', size: 0 },
    { icon: 'icon_maoyishengjijinhui', size: 0 },
    { icon: 'icon_tuxuexuehui', size: 0 },
    { icon: 'icon_qinghuadaxue', size: 0 },
    { icon: 'icon_tongjidaxue', size: 0 },
    { icon: 'icon_changandaxue', size: 0 },
    { icon: 'icon_shenzhenjishudaxue', size: 0 },
    { icon: 'icon_kadifudaxue', size: 0 },
    { icon: 'icon_dianjian', size: 0 },
    { icon: 'icon_shanghaishizhenggongchengshejiyuan', size: 1 },
    { icon: 'icon_zhongyejingcheng', size: 0 },
    { icon: 'icon_huangkanceyanjiuyuan', size: 0 },
    { icon: 'icon_changjiangsheji', size: 0 },
    { icon: 'icon_luqiaojituan', size: 0 },
    { icon: 'icon_zhongchuanjiuyuan', size: 0 },
    { icon: 'icon_xiongan', size: 1 },
    { icon: 'icon_bosch', size: 0 },
    { icon: 'icon_zhongjiaoyihang', size: 0 },
    { icon: 'icon_zhongtieshibaju', size: 1 },
    { icon: 'icon_shanghaichengjianshizheng', size: 0 },
    { icon: 'icon_shanghaichengjianjituan', size: 0 },
    { icon: 'icon_zhongjizhonglian', size: 0 },
    { icon: 'icon_zhongguozhongtie', size: 0 },
    { icon: 'icon_zhongqigongcheng', size: 0 },
    { icon: 'icon_jiaojian', size: 0 },
    { icon: 'icon_fengjiang', size: 0 },
    { icon: 'icon_zhongguojianke', size: 0 },
    { icon: 'icon_zhongchuanghuike', size: 0 },
    { icon: 'icon_xiaotajituan', size: 0 },
    { icon: 'icon_shuyunkeji', size: 0 },
    { icon: 'icon_shanghaixiandaisheji', size: 0 },
    { icon: 'icon_zhongguoshizhonggongchengshejiyuan', size: 1 },
    { icon: 'icon_dongjiao', size: 0 },
    { icon: 'icon_pkpm', size: 0 },
    { icon: 'icon_yunlukeji', size: 0 },
    { icon: 'icon_zhejianggaoxin', size: 0 },
    { icon: 'icon_wuhanshizhengjianshe', size: 1 },
    { icon: 'icon_nantongsijianjituan', size: 1 },
    { icon: 'icon_zhongjiaowuhan', size: 0 },
    { icon: 'icon_dingdangkeji', size: 0 },
    { icon: 'icon_zhufengkeji', size: 0 },
    { icon: 'icon_weitakeji', size: 0 },
    { icon: 'icon_jizhishuke', size: 0 },
]); //合作伙伴列表
const partner_list_fold = ref(true);
const partner_list_height = ref(0);
const partner_list_fold_height = ref(0);

const partner_page_list_computed = computed(() => {
    const pages = [];
    let pageInde = 0;
    for (let i = 0; i < partner_list.value.length; i += partner_grid_line.value * partner_grid_line_count.value) {
        pages.push({ gridList: partner_list.value.slice(i, i + partner_grid_line.value * partner_grid_line_count.value), pageIndex: pageInde });
        pageInde++;
    }
    // 计算列表高度处理折叠
    let totalHeight = 0;
    let foldHeight = 0;
    pages.forEach((element, index) => {
        let line = Math.ceil(element.gridList.length / partner_grid_line_count.value);
        totalHeight += line * (75 + 32);
        if (index < partner_grid_min_line.value) {
            foldHeight += line * (75 + 32);
        }
    });

    partner_list_height.value = totalHeight - 32 + 30;
    partner_list_fold_height.value = foldHeight - 32 + 30;
    document.documentElement.style.setProperty('--home-partner-list-height-compute', partner_list_fold_height.value + 'px');
    return pages;
});

const partner_page_list_size_computed = computed(() => (item) => {
    // let padding = 'padding: 17px 35px;';
    let padding = 'padding: 3px 3px;';
    if (item.size == 1) {
        padding = 'padding: 3px 3px;';
    }
    return padding;
});

// MARK Grid 折叠
const partner_page_list_fold_click = () => {
    partner_list_fold.value = !partner_list_fold.value;
    if (partner_list_fold.value) {
        document.documentElement.style.setProperty('--home-partner-list-height-compute', partner_list_fold_height.value + 'px');
    } else {
        document.documentElement.style.setProperty('--home-partner-list-height-compute', partner_list_height.value + 'px');
    }
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-ecological-patrner-comp {
    position: relative;
    display: flex;
    justify-content: center;
    user-select: none;

    .e-p-content-box {
        position: relative;
        margin-top: 44px;
        width: 100%;
        display: flex;
        align-items: center;

        .change-btn {
            position: relative;
            width: 48px;
            height: 41px;
            cursor: pointer;
            flex-shrink: 0;
        }

        .grid-list-box-unfold {
            height: var(--home-partner-list-height-compute) !important;
        }
        .grid-list-box {
            position: relative;
            display: flex;
            flex-direction: column;
            width: 100%;
            height: var(--home-partner-list-height-compute);
            overflow-y: hidden;
            transition: var(--animation-height-style);

            > :last-child {
                margin-bottom: 0 !important;
            }

            .grid-page-box {
                position: relative;
                margin-bottom: 32px;
                width: 100%;
                flex-shrink: 0;
                display: grid;
                grid-template-columns: repeat(5, 1fr);
                column-gap: 50px;
                row-gap: 32px;
                scroll-snap-align: start;

                .grid-item-box {
                    position: relative;
                    display: flex;
                    height: 75px;
                    align-items: center;
                    justify-content: center;
                    background-color: var(--color-main-light-bg-white);
                    border-radius: 10px;
                    cursor: pointer;
                    box-sizing: border-box;
                    overflow: hidden;
                    box-shadow: var(--color-main-card-shadow-small);

                    img {
                        // width: auto;
                        // height: auto;
                        max-width: 100%;
                        max-height: 100%;
                    }

                    span {
                        position: absolute;
                        top: 5px;
                        left: 5px;
                        font-size: 20px;
                        color: red;
                        font-weight: bold;
                    }
                }
            }

            &::-webkit-scrollbar {
                display: none;
            }
        }
    }

    .top-box {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;

        .top-title {
            position: relative;
            height: 60px;
            font-weight: 500;
            font-size: 40px;
            color: var(--color-main-text-primary);
            line-height: 47px;
            display: flex;
            align-items: center;
        }

        .top-line {
            margin-top: 16px;
            width: 88px;
            height: 6px;
            border-radius: 1px;
            background-color: var(--color-main-brand);
        }
    }

    .e-p-fold-box {
        position: relative;
        margin-top: 32px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        .e-p-fold-btn {
            position: relative;
            height: 42px;
            width: 176px;
            border-radius: 21px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: var(--color-main-home-partner-more-btn-bg);

            .btn-img {
                position: relative;
                width: 24px;
                height: 24px;
            }

            .btn-img-unfold {
                transform: rotate(180deg);
                transition: transform 0.5s ease-in-out;
            }
        }
    }
}
</style>
